<template>
  <b-modal
      id="create-pay-rate"
      ref="create-pay-rate"
      modal-class="pay-rate"
      size="sm-size"
      centered
      hide-footer
      hide-header
      @hide="onModalHide"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get('add_pay_rate') }}
      </h2>
    </div>
    <div class="content-wrapper hasScroll">
      <perfect-scrollbar>
        <div class="form-container">

          <div class="d-flex justify-content-between align-items-center">
            <div class="hourly-rate">
              <h5 class="section-title">
                {{label.get('hourly-rate')}}
              </h5>
              <div
                  class="custom-input-wrapper"
              >
                <span class="currency">$</span>
                <input
                    v-model="payRate.hourly_rate"
                    maxlength="3"
                    step="0.01"
                    value="0.00"
                    placeholder="0.00"
                    @input="onHourlyRateInput"
                    type="number"
                    class="atto-input"
                >
                <span class="hour">/h</span>
              </div>

            </div>

            <div class="effective-from">
              <h5 class="section-title">
                {{label.get('effective_from')}}
              </h5>
              <div class="field-details">
                <simple-datepicker-component
                    :initial-date="payRate.effective_from"
                    :date-format="'MMMM D, YYYY'"
                    :close-on-select="true"
                    @onDateSelected="onDateSelected"
                />
              </div>
            </div>
          </div>
          <div class="error-wrapper">
            <span
                v-if="hourlyRateError && !$v.payRate.hourly_rate.required"
                class="error-message"
            >
              {{label.get('hourly_rate_is_required')}}
            </span>
            <span
                v-if="duplicateDateError"
                class="error-message"
            >
              {{label.get('duplicate_effective_from_error_message')}}
            </span>
          </div>
          <p>{{label.get('add_pay_rate_desc')}}</p>
        </div>
      </perfect-scrollbar>
    </div>
    <div class="modal-footer">
      <div class="form-buttons">
        <button
            class="atto-btn cancel"
            @click="discardCreateMemberPayRates"
        >
          {{ label.get('cancel') }}
        </button>
        <button
            class="atto-btn submit"
            :disabled="disabledSaveButton"
            @click="addPayRate"
        >
          {{ label.get('add_pay_rate') }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
  import {required, maxLength} from 'vuelidate/lib/validators';
  import PayRateService from "../../services/PayRateService";
  import SimpleDatepickerComponent from "../../../../../shared/components/SimpleDatepickerComponent";
  export default {
    name: "CreatePayRateComponent",
    components: {SimpleDatepickerComponent},
    props: {
      userId: {
        type: Number,
        default: 0
      },
      payRates: {
        type: Array,
        default: []
      }
    },
    validations: {
      payRate: {
        hourly_rate: {
          required,
          maxLength: maxLength(6)
        }
      }
    },
    data() {
      return {
        hourlyRateError: false,
        duplicateDateError: false,
        disabledSaveButton: false,
        list: Object.assign([], this.payRates),
        payRate: { user_id: this.userId, job_code_id: null, hourly_rate: null, effective_from: this.$moment().format("YYYY-MM-DD")  }
      }
    },
    mounted() {
      this.$refs['create-pay-rate'].show();
    },
    methods: {
      discardCreateMemberPayRates() {
        this.$refs['create-pay-rate'].hide();
      },
      onModalHide() {
        this.$root.$emit('hideCreatePayRates');
      },
      onDateSelected(date) {
        if (date === undefined || date === null) {
          return;
        }
        this.payRate.effective_from = date;
      },
      onHourlyRateInput(event) {
        const inputElem = event.currentTarget;
        if(inputElem.value === "") {
          return;
        }
        const value = parseFloat(inputElem.value).toFixed(2);
        const [numValue, decimalValue] = value.split('.');

        if (parseInt(numValue) > 999) {
            this.payRate.hourly_rate = numValue.slice(0, 3) + '.' + decimalValue;
        } else if (numValue.length > inputElem.maxLength) {
          this.payRate.hourly_rate = inputElem.value.slice(0, inputElem.maxLength);
        }
      },
      addPayRate() {
        this.hourlyRateError = false;
        this.duplicateDateError = false;
        this.$v.payRate.hourly_rate.$touch();

        if (this.$v.payRate.hourly_rate.$invalid) {
          this.hourlyRateError = true;
          return false;
        }

        this.list.push(this.payRate);
        if(this.checkForDuplicateDates(this.list)) {
          this.duplicateDateError = true;
          return false;
        }

        this.disabledSaveButton = true;
        PayRateService.create(this.payRate).then((result) => {
          this.$root.$emit('hideCreatePayRates', result.data);
        }).catch((error) => {
          this.disabledSaveButton = false;
        });
      },
      checkForDuplicateDates(values) {
        const valueArr = values.map(function(item){ return item.effective_from });
        return valueArr.some(function(item, idx){
          return valueArr.indexOf(item) !== idx;
        });
      }
    }
  }
</script>

<style lang="scss">

  .pay-rate{
    .modal-sm-size{
      width: 416px;
      max-width: 416px;
      .content-wrapper{
        padding: 16px 40px 24px 40px !important;
      }
      .modal-footer{
        padding-top: 16px !important;
      }
    }
    .hourly-rate{

      .custom-input-wrapper{
        display: flex;
        width: 102px;
        height: 40px;
        border: 2px solid $atto-light-grey;

        .currency{
          min-width: 32px;
          height: 36px;
          background: $atto-grey;
          max-width: 32px;
          border-right: 2px solid $atto-light-grey;
          display: flex;
          justify-content: center;
          align-items: center;
          font: $roboto-medium 0.875rem/1.25rem $roboto-font;
          color: $atto-font-color;
        }
        input{
          max-width: 42px;
          min-width: 42px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          text-align: right;
          height: 36px;
          border: none;
          outline: none;
          font: $roboto-medium 0.875rem/1.25rem $roboto-font;
          color: $atto-font-color;

          /* Chrome, Safari, Edge, Opera */
          &::-webkit-outer-spin-button,
          &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }

          /* Firefox */
          &[type=number] {
            -moz-appearance: textfield;
          }
        }

        .hour{
          min-width: 28px;
          max-width: 28px;
          height: 36px;
          margin-top: 1px;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          color: $atto-not-active;
          font: $roboto-medium 0.875rem/1.25rem $roboto-font;
        }
      }
    }

    .effective-from{
      width: 218px;
      .field-details{
        height: 40px;
        margin: 0;
      }
      h5{
        letter-spacing: 0.55px;
      }
    }
    p{
      font: $roboto-regular 0.875rem/1.25rem $roboto-font;
      color: #666666;
      margin: 16px 0 0 0;
    }
  }
</style>